// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "f7a4ca023513c6ab8504314656e234c2" + ".css";
};